export async function statusAr() {
    const url = `${process.env.REACT_APP_SERVER_IP}/feedbackAr`;
    try {
      const response = await fetch(url, {
        method: 'GET', // Requisição GET explícita
      });
      
      if (!response.ok) {
        throw new Error(`Erro HTTP! status: ${response.status}`);
      }
      
      // Processa a resposta como JSON
      const responseData = await response.json();  // Se a resposta for JSON, isso a processa
      console.log('Resposta do servidor:', responseData);
      
      // Se os dados recebidos forem uma string JSON, processamos com JSON.parse
      const parsedData = typeof responseData === 'string' ? JSON.parse(responseData) : responseData;
      
      return parsedData; // Retorna os dados processados para serem usados
    } catch (error) {
      console.error('Erro:', error);
      throw error; // Relança o erro para que o chamador saiba que ocorreu um problema
    }
  }
  